import { render, staticRenderFns } from "./AdminTrading.vue?vue&type=template&id=5ac433e9&scoped=true&"
import script from "./AdminTrading.vue?vue&type=script&lang=js&"
export * from "./AdminTrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac433e9",
  null
  
)

export default component.exports